import {
  CUSTOMERS_BATCH_DELETE_REQUEST,
  CUSTOMERS_BATCH_DELETE_SUCCESS,
  CUSTOMERS_BATCH_DELETE_FAILURE,
  CUSTOMERS_FETCH_MANY_REQUEST,
  CUSTOMERS_FETCH_MANY_SUCCESS,
  CUSTOMERS_FETCH_MANY_FAILURE,
  CUSTOMERS_FETCH_REQUEST,
  CUSTOMERS_FETCH_SUCCESS,
  CUSTOMERS_FETCH_FAILURE,
  CUSTOMERS_SAVE_REQUEST,
  CUSTOMERS_SAVE_SUCCESS,
  CUSTOMERS_SAVE_FAILURE,

  EMPTY_CUSTOMERS,
  CLEAR_ERRORS
} from './types'

export default {
  deleteMany ({ commit }, { ids = [] }) {
    commit(CUSTOMERS_BATCH_DELETE_REQUEST)
    return window.axios.post('/customers', { _method: 'DELETE', ids }).then(response => {
      commit(CUSTOMERS_BATCH_DELETE_SUCCESS, response)
      return response
    }).catch(error => {
      commit(CUSTOMERS_BATCH_DELETE_FAILURE, error)
      throw error
    })
  },
  fetchMany ({ commit }, { query = '', page = 1, extraParams = {} }) {
    commit(CUSTOMERS_FETCH_MANY_REQUEST)
    return window.axios.get('/customers', { params: { query, page, ...extraParams } }).then(response => {
      commit(CUSTOMERS_FETCH_MANY_SUCCESS, response)
      return response
    }).catch(error => {
      commit(CUSTOMERS_FETCH_MANY_FAILURE, error)
      throw error
    })
  },
  fetch ({ commit }, id) {
    commit(CUSTOMERS_FETCH_REQUEST)
    return window.axios.get(`/customers/${id}`).then(response => {
      commit(CUSTOMERS_FETCH_SUCCESS, response)
      return response
    }).catch(error => {
      commit(CUSTOMERS_FETCH_FAILURE, error)
      throw error
    })
  },
  save ({ commit }, user) {
    const path = user.id ? `/customers/${user.id}` : '/customers'
    const method = user.id ? 'put' : 'post'

    commit(CUSTOMERS_SAVE_REQUEST)
    return window.axios[method](path, user).then(response => {
      commit(CUSTOMERS_SAVE_SUCCESS, response)
      return response
    }).catch(error => {
      if (error.response.status === 422) {
        commit(CUSTOMERS_SAVE_FAILURE, { validationErrors: error.response.data })
      } else {
        commit(CUSTOMERS_SAVE_FAILURE, { error })
      }
      throw error
    })
  },
  empty({ commit }) {
    commit(EMPTY_CUSTOMERS);
  },
  clearErrors({ commit }) {
    commit(CLEAR_ERRORS)
  }
}
